import axios from 'axios'
import '@babel/polyfill'
import 'mutationobserver-shim'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
import Vue from 'vue';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './plugins'
import App from './App.vue'
import router from './router'
import store from './store'
import './directives'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueHtml2pdf from 'vue-html2pdf'
import Camera from 'easy-vue-camera';
import { BSpinner } from 'bootstrap-vue';
import VueSuggestion from 'vue-suggestion';
import VueClipboard from 'vue-clipboard2';
// import VueI18n from 'vue-i18n';

// Vue.use(VueI18n);
Vue.use(VueClipboard);
Vue.use(VueSuggestion);
Vue.use(Vuetify)
Vue.use(VueHtml2pdf);
Vue.use(Camera);
Vue.component('b-spinner', BSpinner);
const vuetify = new Vuetify({
  // Vuetify 옵션
})
const options = {
  autoClose: true,
}

Vue.use(VueHtmlToPaper, options);

// 저장·수집 요청이 도는 동안에는 계정을 바꾸면 안 된다.
// 화면마다 플래그를 심으면 하나씩 빠뜨리므로 요청 자체를 한 곳에서 센다.
const WRITE_URL = /\/api\/.*(save|update)/i;
axios.interceptors.request.use(config => {
  if (WRITE_URL.test(config.url || '')) {
    config._countedAsWrite = true;
    store.commit('ledgerWriteStart');
  }
  return config;
});
axios.interceptors.response.use(
  res => {
    if (res.config && res.config._countedAsWrite) store.commit('ledgerWriteEnd');
    return res;
  },
  err => {
    if (err.config && err.config._countedAsWrite) store.commit('ledgerWriteEnd');
    return Promise.reject(err);
  }
);

// 수집은 확장으로 postMessage 를 던져 시작하고, 끝나면 확장이 같은 방식으로 알려준다.
// 페이지가 자기 자신에게 보낸 메시지도 여기로 들어오므로 시작·끝을 모두 잡을 수 있다.
window.addEventListener('message', (e) => {
  if (e.source !== window || !e.data || !e.data.itemKey) return;

  if (e.data.greeting === 'manualCollect') {
    const key = e.data.itemKey;
    store.commit('collectStart', key);
    // 확장이 완료를 못 알리는 경우(탭을 닫았거나 구버전)에 갇히지 않게 하는 안전장치.
    // 상품DB 수집이 실측 10분대라 넉넉히 잡는다
    setTimeout(() => store.commit('collectEnd', key), 60 * 60 * 1000);
  }
  if (e.data.type === 'manualCollectComplete') {
    store.commit('collectEnd', e.data.itemKey);
  }
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
